import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchPhases: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'phase/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_PHASE_REQUEST,
                        types.SEARCH_PHASE_SUCCESS,
                        types.SEARCH_PHASE_FAILURE
                    ]
                }
            });
        },

    savePhase: (phase) =>
        (dispatch) => {
            if (phase.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'phase/create',
                        method: 'POST',
                        body: phase,
                        types: [
                            types.CREATE_PHASE_REQUEST,
                            types.CREATE_PHASE_SUCCESS,
                            types.CREATE_PHASE_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'phase/update',
                        method: 'PUT',
                        body: phase,
                        types: [
                            types.UPDATE_PHASE_REQUEST,
                            types.UPDATE_PHASE_SUCCESS,
                            types.UPDATE_PHASE_FAILURE
                        ]
                    }
                });
            }
        }
}
